var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBiPlayCircleFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2595_14358)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 19C38 24.0391 35.9982 28.8718 32.435 32.435C28.8718 35.9982 24.0391 38 19 38C13.9609 38 9.12816 35.9982 5.56497 32.435C2.00178 28.8718 0 24.0391 0 19C0 13.9609 2.00178 9.12816 5.56497 5.56497C9.12816 2.00178 13.9609 0 19 0C24.0391 0 28.8718 2.00178 32.435 5.56497C35.9982 9.12816 38 13.9609 38 19ZM16.1262 12.0959C15.9487 11.9695 15.7398 11.8943 15.5223 11.8788C15.3049 11.8632 15.0874 11.9078 14.8936 12.0076C14.6999 12.1074 14.5373 12.2587 14.4238 12.4447C14.3103 12.6308 14.2501 12.8445 14.25 13.0625V24.9375C14.2501 25.1555 14.3103 25.3692 14.4238 25.5553C14.5373 25.7413 14.6999 25.8926 14.8936 25.9924C15.0874 26.0922 15.3049 26.1368 15.5223 26.1212C15.7398 26.1057 15.9487 26.0305 16.1262 25.9041L24.4387 19.9666C24.5927 19.8568 24.7182 19.7118 24.8047 19.5436C24.8913 19.3755 24.9365 19.1891 24.9365 19C24.9365 18.8109 24.8913 18.6245 24.8047 18.4564C24.7182 18.2882 24.5927 18.1432 24.4387 18.0334L16.1262 12.0959Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2595_14358"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBiPlayCircleFill);
export default __webpack_public_path__ + "static/media/bi_play-circle-fill.635262308bb718a12ed045dd6113518d.svg";
export { ForwardRef as ReactComponent };